export default __webpack_public_path__ + "static/media/figo-pet-tag.91a4ba5a.svg";